import React, { useEffect, useRef, useState } from "react";
import AllSamplesStyle from "./allsamples.module.css";
import ReactEcharts from "echarts-for-react";
import { Button, Select } from "antd";
import S18_LeafScatter from "../../../../../assets/json/Express/RanSeq/RNA-seq-ALL-samples(1)/lotus_trans_pca/Comparative_Transcriptome_of_Lotus_Seed_Cotyledon_Development";
import S36_CotyledonScatter from "../../../../../assets/json/Express/RanSeq/RNA-seq-ALL-samples(1)/lotus_trans_pca/Transcriptome_of_Lotus_Seed_Cotyledon_Development";
import S36_PlumuleScatter from "../../../../../assets/json/Express/RanSeq/RNA-seq-ALL-samples(1)/lotus_trans_pca/Transcriptome_of_Lotus_Seed_Plumule_Development";
import S18_LeafHeat from "../../../../../assets/json/Express/RanSeq/RNA-seq-ALL-samples(1)/lotus_trans_heatmap/Comparative_Transcriptome_of_Lotus_Seed_Cotyledon_Development";
import S36_CotyledonHeat from "../../../../../assets/json/Express/RanSeq/RNA-seq-ALL-samples(1)/lotus_trans_heatmap/Transcriptome_of_Lotus_Seed_Cotyledon_Development";
import S36_PlumuleHeat from "../../../../../assets/json/Express/RanSeq/RNA-seq-ALL-samples(1)/lotus_trans_heatmap/Transcriptome_of_Lotus_Seed_Plumule_Development";
function AllSamples() {
  const heatRef = useRef();

  const [ScatterChange, setScatterChange] = useState("S18_Leaf");
  const [ScatterOptions, setScatterOptions] = useState({});
  useEffect(() => {
    if (ScatterChange == "S18_Leaf") {
      console.log(S18_LeafScatter)
      setScatterOptions({
        title: {
          text: "Principal Component Analysis",
        },
        xAxis: {
          type: "value",
          name: "PC1",
        },
        yAxis: {
          type: "value",
          name: "PC2",
        },
        legend: {
          data: Object.keys(S18_LeafScatter),  // 图例项
          orient: "horizontal",  // 图例横向排列
         
          right: "10%",  // 设置右边距
          bottom: "15",  // 设置上边距
          textStyle: {
            color: '#333',  // 设置文字颜色
            fontSize: 12,  // 设置文字大小
          },
        },
        series: Object.entries(S18_LeafScatter).map(
          ([category, samplesObj]) => {
            // 将对象转换为数组，每个样本作为数组的一个元素
            const dataArray = Object.values(samplesObj).map((sample) => ({
              sample: sample.sample,
              PC1: parseFloat(sample.PC1),
              PC2: parseFloat(sample.PC2),
              // pc3: sample.pc3, // 假定pc3存在
            }));

            return {
              name: category, // 分类名
              type: "scatter",
              data: dataArray.map((item) => [item.PC1, item.PC2]), // 提PC和pc2作为x,y坐标
              symbolSize: 10, // 点的大小
              label: {
                show: true,
                formatter: "{b}", // 显示数据样本标签，此处为样本名称
              },
              emphasis: {
                focus: "series",
              },
            };
          }
        ),
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            // 直接从数组中取值，注意params.data在这里是数组
            return `PC1: ${params.data[0]}<br>PC2: ${params.data[1]}`;
          },
        },
      });
    }
    if (ScatterChange == "S36_Cotyledon") {
      console.log(S36_CotyledonScatter)
      setScatterOptions({
        title: {
          text: "Principal Component Analysis",
        },
        xAxis: {
          type: "value",
          name: "PC1",
        },
        yAxis: {
          type: "value",
          name: "PC2",
        },
        legend: {
          data: Object.keys(S36_CotyledonScatter),  // 图例项
          orient: "horizontal",  // 图例横向排列
         
          right: "10%",  // 设置右边距
          bottom: "15",  // 设置上边距
          textStyle: {
            color: '#333',  // 设置文字颜色
            fontSize: 12,  // 设置文字大小
          },
        },
        series: Object.entries(S36_CotyledonScatter).map(
          ([category, samplesObj]) => {
            // 将对象转换为数组，每个样本作为数组的一个元素
            const dataArray = Object.values(samplesObj).map((sample) => ({
              sample: sample.sample,
              PC1: parseFloat(sample.PC1),
              PC2: parseFloat(sample.PC2),
              // pc3: sample.pc3, // 假定pc3存在
            }));

            return {
              name: category, // 分类名
              type: "scatter",
              data: dataArray.map((item) => [item.PC1, item.PC2]), // 提PC和pc2作为x,y坐标
              symbolSize: 10, // 点的大小
              label: {
                show: true,
                formatter: "{b}", // 显示数据样本标签，此处为样本名称
              },
              emphasis: {
                focus: "series",
              },
            };
          }
        ),
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            // 直接从数组中取值，注意params.data在这里是数组
            return `PC1: ${params.data[0]}<br>PC2: ${params.data[1]}`;
          },
        },
      });
    }
    if (ScatterChange == "S36_Plumule") {
      console.log(S36_PlumuleScatter)
      setScatterOptions({
        title: {
          text: "Principal Component Analysis",
        },
        xAxis: {
          type: "value",
          name: "PC1",
        },
        yAxis: {
          type: "value",
          name: "PC2",
        },
        legend: {
          data: Object.keys(S36_PlumuleScatter),  // 图例项
          orient: "horizontal",  // 图例横向排列
         
          right: "10%",  // 设置右边距
          bottom: "15",  // 设置上边距
          textStyle: {
            color: '#333',  // 设置文字颜色
            fontSize: 12,  // 设置文字大小
          },
        },
        series: Object.entries(S36_PlumuleScatter).map(
          ([category, samplesObj]) => {
            // 将对象转换为数组，每个样本作为数组的一个元素
            const dataArray = Object.values(samplesObj).map((sample) => ({
              sample: sample.sample,
              PC1: parseFloat(sample.PC1),
              PC2: parseFloat(sample.PC2),
              // pc3: sample.pc3, // 假定pc3存在
            }));

            return {
              name: category, // 分类名
              type: "scatter",
              data: dataArray.map((item) => [item.PC1, item.PC2]), // 提PC和pc2作为x,y坐标
              symbolSize: 10, // 点的大小
              label: {
                show: true,
                formatter: "{b}", // 显示数据样本标签，此处为样本名称
              },
              emphasis: {
                focus: "series",
              },
            };
          }
        ),
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            // 直接从数组中取值，注意params.data在这里是数组
            return `PC1: ${params.data[0]}<br>PC2: ${params.data[1]}`;
          },
        },
      });
    }
  }, [ScatterChange]);

  const [HeatChange, setHeatChange] = useState("S18_Leaf");
  const [HeatOptions, setHeatOpions] = useState({});
  useEffect(() => {
    console.log(HeatChange);
    if (HeatChange == "S18_Leaf") {
      let S18Data=S18_LeafHeat.data.map(item => item[2])
      console.log(S18Data)
      setHeatOpions({
        title: {
          text: "Pearson Correlation Coefficient Heatmap",
        },
        // ...其他配置...
        tooltip: {
          position: "top",
        },
        visualMap: {
          min: Math.min(...S18Data), // 设置visualMap的最小值为0.5
          max: Math.max(...S18Data), // 设置visualMap的最大值为1.0
          calculable: true,

          precision: 1, //数据展示的小数精度，默认为0，无小数点
          splitNumber: 5, // 正确拼写
          right: 0,
          top: 50,
          inRange: {
            color: ["#fff", "#238AA1"], // 设置颜色范围从白色到深蓝色
          },
          textStyle: {
            color: "#333", // 设置文本颜色
          },
        },
        xAxis: {
          type: "category",
          data: S18_LeafHeat.x_labels,
          axisLabel: {
            rotate: 45, // 根据需要调整旋转角度
          },
        },
        yAxis: {
          type: "category",
          data: S18_LeafHeat.y_labels,
        },
        series: [
          {
            type: "heatmap",
            data: S18_LeafHeat.data,
          },
        ],
      });
    }
    if (HeatChange == "S36_Cotyledon") {
      console.log("Coty", S36_CotyledonHeat);
      let S36Data=S36_CotyledonHeat.data.map(item => item[2])
      setHeatOpions({
        title: {
          text: "Pearson Correlation Coefficient Heatmap",
        },
        // ...其他配置...
        tooltip: {
          position: "top",
        },
        visualMap: {
          min: Math.min(...S36Data), // 设置visualMap的最小值为0.5
          max: Math.max(...S36Data), // 设置visualMap的最大值为1.0
          calculable: true,

          precision: 1, //数据展示的小数精度，默认为0，无小数点
          splitNumber: 5, // 正确拼写
          right: 0,
          top: 50,
          inRange: {
            color: ["#fff", "#238AA1"], // 设置颜色范围从白色到深蓝色
          },
          textStyle: {
            color: "#333", // 设置文本颜色
          },
        },
        xAxis: {
          type: "category",
          data: S36_CotyledonHeat.x_labels,
          axisLabel: {
            rotate: 45, // 根据需要调整旋转角度
          },
        },
        yAxis: {
          type: "category",
          data: S36_CotyledonHeat.y_labels,
        },
        series: [
          {
            type: "heatmap",
            data: S36_CotyledonHeat.data,
          },
        ],
      });
    }
    if (HeatChange == "S36_Plumule") {
      console.log("Plumu", S36_PlumuleHeat);
      let S36Data=S36_PlumuleHeat.data.map(item => item[2])
      setHeatOpions({
        title: {
          text: "Pearson Correlation Coefficient Heatmap",
        },
        // ...其他配置...
        tooltip: {
          position: "top",
        },
        visualMap: {
          min: Math.min(...S36Data), // 设置visualMap的最小值为0.5
          max: Math.max(...S36Data), // 设置visualMap的最大值为1.0
          calculable: true,

          precision: 1, //数据展示的小数精度，默认为0，无小数点
          splitNumber: 5, // 正确拼写
          right: 0,
          top: 50,
          inRange: {
            color: ["#fff", "#238AA1"], // 设置颜色范围从白色到深蓝色
          },
          textStyle: {
            color: "#333", // 设置文本颜色
          },
        },
        xAxis: {
          type: "category",
          data: S36_PlumuleHeat.x_labels,
          axisLabel: {
            rotate: 45, // 根据需要调整旋转角度
          },
        },
        yAxis: {
          type: "category",
          data: S36_PlumuleHeat.y_labels,
          
        },
        series: [
          {
            type: "heatmap",
            data: S36_PlumuleHeat.data,
          },
        ],
      });
    }
  }, [HeatChange]);

  return (
    <div className={AllSamplesStyle.AllSamples_app}>
      <div className={AllSamplesStyle.AllSamples_scatter}>
        <ReactEcharts
          option={ScatterOptions}
          style={{ height: "90%", width: "100%" }}
        />
        <div className={AllSamplesStyle.AllSamples_buttons}>
         <Select
         style={{width:"80%"}}
         defaultValue={['Comparative Transcriptome of Lotus Seed Cotyledon Development']}
         options={[
          {
            key:"1",
            label:"Comparative Transcriptome of Lotus Seed Cotyledon Development",
            value:"S18_Leaf"
          }, {
            key:"2",
            label:"Transcriptome of Lotus Seed Cotyledon Development",
            value:"S36_Cotyledon"
          }, {
            key:"3",
            label:"Transcriptome of Lotus Seed Plumule Development",
            value:"S36_Plumule"
          },
         ]}
         onChange={(e)=>{
          setScatterChange(e)
         }}
         />
        </div>
      </div>
      <div className={AllSamplesStyle.AllSamples_heatmap}>
        <ReactEcharts
          cell={<text>54</text>}
          ref={heatRef}
          option={HeatOptions}
          style={{ height: "90%", width: "100%" }}
        />
        <div className={AllSamplesStyle.AllSamples_buttons}>
        <Select
         style={{width:"80%"}}
         defaultValue={['Comparative Transcriptome of Lotus Seed Cotyledon Development']}
         options={[
          {
            key:"1",
            label:"Comparative Transcriptome of Lotus Seed Cotyledon Development",
            value:"S18_Leaf"
          }, {
            key:"2",
            label:"Transcriptome of Lotus Seed Cotyledon Development",
            value:"S36_Cotyledon"
          }, {
            key:"3",
            label:"Transcriptome of Lotus Seed Plumule Development",
            value:"S36_Plumule"
          },
         ]}
         onChange={(e)=>{
          setHeatChange(e)
         }}
         />
        </div>
      </div>
    </div>
  );
}

export default AllSamples;
